export default __webpack_public_path__ + "static/media/Gel.39e2159c.svg";